import { Interface } from "@ethersproject/abi";
import {  Provider as ProviderType } from "@ethersproject/providers";
import { ethers } from "ethers";
import { NetworkType } from "..";
import erc20Token from "../abis/ERC20.json"


export const getSourceTokenApproval = async ({
    tokenAddress,
    sourceNetworkId,
    destinationNetworkId,
    userAddress,
    provider,
    network_config
    // spenderAddress, // Cross chain reserve handler / same chain one-split
}: {
    tokenAddress: string,
    sourceNetworkId: string,
    destinationNetworkId: string,
    userAddress: string,
    provider:ProviderType,
    network_config:{ [chainId: string]: NetworkType }
    // spenderAddress: string
}) => {
    try {
        let spenderAddress;
        if(sourceNetworkId===destinationNetworkId){
            spenderAddress=network_config[sourceNetworkId].oneSplit;
        } else {
            spenderAddress=network_config[sourceNetworkId].reserveHandler;
        }

        const erc20Instance = new ethers.Contract(
            tokenAddress,
            erc20Token,
            provider
        );
        const result = await erc20Instance.allowance(
            userAddress,
            spenderAddress
        );
        return result;
    } catch (error) {
        console.log("Error", error);
    }
}

export const getFeeTokenApproval = async ({
    tokenAddress,
    networkId,
    userAddress,
    provider,
    network_config
}: {
    tokenAddress: string,
    networkId: string
    userAddress: string,
    provider: ProviderType,
    network_config:{ [chainId: string]: NetworkType }
}) => {
    try {
        const spenderAddress=network_config[networkId].reserveHandler;
        const erc20Instance = new ethers.Contract(
            tokenAddress,
            erc20Token,
            provider
        );
        const result = await erc20Instance.allowance(
            userAddress,
            spenderAddress
        );
        return result;
    } catch (error) {
        console.log("Error", error);
    }
}

export const setSourceTokenApproval = async ({
    tokenAddress,
    userAddress,
    amount,
    sourceNetworkId,
    destinationNetworkId,
    network_config
}: {
    tokenAddress: string
    userAddress: string
    amount: string
    sourceNetworkId: string,
    destinationNetworkId: string,
    network_config:{ [chainId: string]: NetworkType }
}) => {
    let spenderAddress;
        if(sourceNetworkId===destinationNetworkId){
            spenderAddress=network_config[sourceNetworkId].oneSplit;
        } else {
            spenderAddress=network_config[sourceNetworkId].reserveHandler;
        }
    try {
        const iface = new Interface(erc20Token);
        const rawData= iface.encodeFunctionData("approve",[
            spenderAddress,
            amount
        ])
        return {
           to:tokenAddress,
           from:userAddress,
           data:rawData,
        };
    } catch (error) {
        console.log("Error", error);
        return undefined
    }
}

export const setFeeTokenApproval = async ({
    amount,
    tokenAddress,
    userAddress,
    sourceNetworkId,
    network_config
}: {
    amount: string,
    tokenAddress: string
    userAddress: string
    sourceNetworkId: string,
    network_config:{ [chainId: string]: NetworkType }
}) => {
    const spenderAddress=network_config[sourceNetworkId].reserveHandler;
    try {
        const iface = new Interface(erc20Token);
        const rawData= iface.encodeFunctionData("approve",[
            spenderAddress,
            amount
        ])
        return {
            to:tokenAddress,
            from:userAddress,
            data:rawData,
         };
        
        } catch (error) {
        console.log("Error", error);
        return undefined
    }
}